
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gdDdaj6MTWCAsZnEfGsGIdHvGinE8b2VVgGqEufjhNm4Meta } from "/codebuild/output/src1355690107/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexIBnGhrkNmEhwLJNbasQxoH23_ekOKLJ_AcdV_c_457YXIMeta } from "/codebuild/output/src1355690107/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchncmpGxLgr0k04SdCYxl9kGuDy7vtQvvgqpktmKOaz_450Meta } from "/codebuild/output/src1355690107/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexoEqsNg55MeLbnMcoailC751iY4cUZN3dPkfmxySr4eAMeta } from "/codebuild/output/src1355690107/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_931TfeBekQkHMaMA2kEY85F5tqyvEZbk3U63K2Zm4lDUkMeta } from "/codebuild/output/src1355690107/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as index_6pQrK8AUCIpLqPV0xZToNS2E_45m3BlwiO5WwSTAQ5uEMeta } from "/codebuild/output/src1355690107/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93IcAtyyPwNVtctPm_45EXN7GiOyqW0VZIPHl8Ifc9xednMMeta } from "/codebuild/output/src1355690107/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexHJUPHeoXmBpXXIdeWKM3sBZARAvNLQE5hJP8LXLQRZwMeta } from "/codebuild/output/src1355690107/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93dIDuwqF02tnWNndD0p1ysyXaOnQnkhA4EPtzcbF0KmoMeta } from "/codebuild/output/src1355690107/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexqWGjXcrKCUD1_EJXleiyxpqUGFtp5Xf9w6bjneM_45XD4Meta } from "/codebuild/output/src1355690107/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexrguTN8R_45FMqUIq_45bz0B5gVqYWkmNQLXUFZEuJOvIKdwMeta } from "/codebuild/output/src1355690107/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src1355690107/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src1355690107/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src1355690107/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src1355690107/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src1355690107/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: index_6pQrK8AUCIpLqPV0xZToNS2E_45m3BlwiO5WwSTAQ5uEMeta || {},
    component: () => import("/codebuild/output/src1355690107/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src1355690107/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexHJUPHeoXmBpXXIdeWKM3sBZARAvNLQE5hJP8LXLQRZwMeta || {},
    component: () => import("/codebuild/output/src1355690107/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src1355690107/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexqWGjXcrKCUD1_EJXleiyxpqUGFtp5Xf9w6bjneM_45XD4Meta || {},
    component: () => import("/codebuild/output/src1355690107/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexrguTN8R_45FMqUIq_45bz0B5gVqYWkmNQLXUFZEuJOvIKdwMeta || {},
    component: () => import("/codebuild/output/src1355690107/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]